(ns app.front.view.group.admin.config.upper-tier-visibility
  (:require [app.domain.group.model :as group-model]
            [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]))

(defn view [group-id & [section-options]]
  (when-some [other-groups (seq (<sub [::gas/groups-sharing-municipalities]))]
    (let [tr                 (<sub [::gas/group-tr])
          current-group      (<sub [::gas/group])
          current-group-name (:group/name current-group)]
      [acommon/config-section
       (tr [:group-admin/upper-tier-visibility-title])
       [:div.bx--col-xs-12
        [:div (tr [:group-admin/upper-tier-visibility-other-orgs]
                  [current-group-name])]
        [:div
         [:ul.mt-4
          (for-frag [{group-name :group/name} other-groups]
            [:li.mt-1
             [:span.font-bold group-name]])]]
        [:div
         [ui/help (tr [:group-admin/upper-tier-visibility-warning])]]
        [:div.flex
         (cc/toggle {:id         "upper-tier-visibility-switch"
                     :label-text (tr [:group-admin/upper-tier-visibility-switch]
                                     [(tr [(if (group-model/application-authority? current-group)
                                             :group.type/upper-tier-authority
                                             :group.type/application-authority)])
                                      current-group-name])
                     :toggled    (group-model/has-feature? current-group :group.feature/workspaces-visible-outside-domain-group)
                     :on-toggle  #(>evt [::feature-toggle/toggle-group-feature
                                         group-id
                                         :group.feature/workspaces-visible-outside-domain-group
                                         %])})]]
       section-options])))
